import { render } from "./articleBase.vue?vue&type=template&id=08c11824"
import script from "./articleBase.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./articleBase.vue?vue&type=script&charset=utf-8&lang=js"

import "./articleBase.vue?vue&type=style&index=0&id=08c11824&lang=scss"

import exportComponent from "/home/th3g3ntl3man/github/blog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__